export const DISCORD_URL = 'https://discord.com/invite/r3mXe6kM8Z'
